import { render, staticRenderFns } from "./ListFeeChildRule.vue?vue&type=template&id=45d6a08e&"
import script from "./ListFeeChildRule.vue?vue&type=script&lang=js&"
export * from "./ListFeeChildRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports